// //þessi útgáfa sækir úr json file
// // frontend/src/pages/DoctorChangesPage.tsx
// import React, { useEffect, useMemo, useState } from 'react';
// import '../styles/DoctorChangesPage.css';
// import Header from '../components/Header/Header';
// import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
// import { useNavigate } from 'react-router-dom';
// import Background from '../components/Background/Background';
// import { useAuth0 } from '@auth0/auth0-react';
// import { fetchWithAuth } from '../api/fetchWithAuth';

// type EffectiveKind = 'immediate' | 'next_cycle';
// type ReviewStatus = 'pending' | 'reviewed' | 'archived';

// type ActionItem = {
//   name: string;
//   instruction?: string;
//   effective?: EffectiveKind;
// };

// type PharmacistDecision = {
//   medicationName: string;
//   kind: 'add' | 'edit' | 'remove';
//   decision: 'approved' | 'rejected';
//   effective: EffectiveKind | null;
//   reason: string | null;
//   decidedAt: string;
// };

// type ChangeEntry = {
//   name: string;
//   ssn: string;
//   date: string;
//   time: string;
//   sender: string;
//   phone: string;
//   reviewStatus?: ReviewStatus;
//   reviewedAt?: string | null;
//   actions?: {
//     add?: ActionItem[];
//     edit?: ActionItem[];
//     remove?: ActionItem[];
//     pharmacist?: PharmacistDecision[];
//   };
// };

// type Bucket = 'sent' | 'rejected' | 'approved';

// function itemKey(kind: 'add' | 'edit' | 'remove', name: string) {
//   return `${kind}::${name}`;
// }

// export default function DoctorChangesPage() {
//   const [activeTab, setActiveTab] = useState<'medications' | 'history'>('history');
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string>('');
//   const [changes, setChanges] = useState<ChangeEntry[]>([]);
//   const [showApproved, setShowApproved] = useState(false);
//   const [ssn, setSsn] = useState('');

//   const { getAccessTokenSilently } = useAuth0();
//   const API_BASE = 'http://localhost:4000';

//   const handleSearch = async () => {
//     const ssnTrimmed = ssn.trim();
//     if (!ssnTrimmed) return;

//     try {
//       const res = await fetchWithAuth(getAccessTokenSilently, `${API_BASE}/api/patients/search`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ ssn: ssnTrimmed }),
//       });

//       if (res.status === 404) {
//         navigate('/notfound');
//         return;
//       }

//       if (!res.ok) {
//         const text = await res.text();
//         throw new Error(`API ${res.status}: ${text}`);
//       }

//       const data = await res.json();
//       console.log('PATIENT FROM API:', data);
//       console.log(
//         'MED IDS:',
//         data.medications?.map((m: any) => m.id)
//       );
//       const newPatientId = data.patientId as string | undefined;
//       if (!newPatientId) throw new Error('Missing patientId in search response');

//       navigate(`/doctor/patient/${encodeURIComponent(newPatientId)}`, {
//         state: { name: data.name, pharmacy: data.pharmacy },
//       });
//     } catch (e) {
//       console.error(e);
//       navigate('/notfound');
//     }
//   };

//   const searchProps: SearchBarProps = {
//     value: ssn,
//     onChange: setSsn,
//     onSearch: handleSearch,
//     onMenuClick: () => console.log('menu'),
//   };

//   useEffect(() => {
//     (async () => {
//       try {
//         setLoading(true);
//         setError('');
//         const res = await fetchWithAuth(getAccessTokenSilently, `${API_BASE}/api/changes`);
//         if (!res.ok) {
//           const text = await res.text();
//           throw new Error(`API ${res.status}: ${text}`);
//         }
//         const data = (await res.json()) as ChangeEntry[];
//         setChanges(Array.isArray(data) ? data : []);
//       } catch (e: any) {
//         console.error(e);
//         setError(e?.message || 'Villa kom upp');
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, [getAccessTokenSilently]);

//   const categorized = useMemo(() => {
//     const sent: (ChangeEntry & { rejectedCount: number })[] = [];
//     const rejected: (ChangeEntry & { rejectedCount: number })[] = [];
//     const approved: (ChangeEntry & { rejectedCount: number })[] = [];

//     for (const entry of changes) {
//       const acts = entry.actions ?? {};
//       const add = acts.add ?? [];
//       const edit = acts.edit ?? [];
//       const remove = acts.remove ?? [];
//       const pharmacist = acts.pharmacist ?? [];

//       // Items that require a pharmacist decision (unique by kind+name)
//       const requiredKeys = new Set<string>();
//       add.forEach((a) => requiredKeys.add(itemKey('add', a.name)));
//       edit.forEach((a) => requiredKeys.add(itemKey('edit', a.name)));
//       remove.forEach((a) => requiredKeys.add(itemKey('remove', a.name)));

//       // Decisions (unique by kind+medicationName)
//       const decided = new Map<string, PharmacistDecision>();
//       pharmacist.forEach((p) => decided.set(itemKey(p.kind, p.medicationName), p));

//       const rejectedCount = Array.from(decided.values()).filter(
//         (d) => d.decision === 'rejected'
//       ).length;

//       const allDecided =
//         requiredKeys.size > 0 && Array.from(requiredKeys.values()).every((k) => decided.has(k));

//       const allApproved =
//         allDecided &&
//         Array.from(requiredKeys.values()).every((k) => decided.get(k)?.decision === 'approved');

//       const anyRejected = rejectedCount > 0;

//       // SENT = not reviewed yet (pending) OR missing full decisions
//       // HAFNAÐ = anyRejected
//       // SAMÞYKKT = allApproved
//       let bucket: Bucket = 'sent';
//       if (allApproved) bucket = 'approved';
//       else if (anyRejected) bucket = 'rejected';
//       else bucket = 'sent';

//       const withMeta = { ...entry, rejectedCount };

//       if (bucket === 'approved') approved.push(withMeta);
//       else if (bucket === 'rejected') rejected.push(withMeta);
//       else sent.push(withMeta);
//     }

//     // newest first (simple: date+time string sort fallback)
//     const sortDesc = (a: ChangeEntry, b: ChangeEntry) =>
//       `${b.date} ${b.time}`.localeCompare(`${a.date} ${a.time}`);

//     sent.sort(sortDesc);
//     rejected.sort(sortDesc);
//     approved.sort(sortDesc);

//     return { sent, rejected, approved };
//   }, [changes, getAccessTokenSilently]);

//   return (
//     <>
//       <Header
//         title="Rx"
//         userName="Jón Jónsson"
//         center={<SearchBar {...searchProps} />}
//       />

//       <div className="tabs">
//         <button
//           className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
//           onClick={() => {
//             setActiveTab('medications');
//             navigate('/doctor');
//           }}
//         >
//           Lyfjaskammtanir
//         </button>
//         <button
//           className={`tab ${activeTab === 'history' ? 'active' : ''}`}
//           onClick={() => {
//             setActiveTab('history');
//             navigate('/doctor/changes');
//           }}
//         >
//           Þínar fyrri breytingar
//         </button>
//       </div>

//       <Background>
//         <div className="changes-container">
//           <h2>Þínar breytingar á skömmtunum</h2>

//           {loading && <div style={{ color: '#fff' }}>Hleð…</div>}
//           {error && <div style={{ color: '#fff' }}>{error}</div>}

//           {!loading && !error && (
//             <>
//               {/* Hafnað */}
//               <div className="status-section">
//                 <div className="status-title">Hafnað</div>
//                 {categorized.rejected.length === 0 && <div className="empty">Engar hafnaðar.</div>}

//                 {categorized.rejected.map((e) => (
//                   <div
//                     key={`rej-${e.ssn}-${e.date}-${e.time}`}
//                     className="status-item rejected clickable"
//                     onClick={() => navigate(`/doctor/changes/${encodeURIComponent(e.ssn.trim())}`)}
//                     role="button"
//                     tabIndex={0}
//                   >
//                     <span>
//                       {e.name} - {e.ssn}
//                     </span>

//                     {/* red dot = how many rows rejected */}
//                     {e.rejectedCount > 0 && (
//                       <div className="notification-dot">{e.rejectedCount}</div>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* Sent */}
//               <div className="status-section">
//                 <div className="status-title">Sent</div>
//                 {categorized.sent.length === 0 && <div className="empty">Engar óafgreiddar.</div>}

//                 {categorized.sent.map((e) => (
//                   <div
//                     key={`sent-${e.ssn}-${e.date}-${e.time}`}
//                     className="status-item sent clickable"
//                     onClick={() => navigate(`/doctor/changes/${encodeURIComponent(e.ssn.trim())}`)}
//                     role="button"
//                     tabIndex={0}
//                   >
//                     {e.name} - {e.ssn}
//                   </div>
//                 ))}
//               </div>

//               {/* Samþykkt (expandable) */}
//               <div className="status-section">
//                 <div
//                   className="status-title expandable"
//                   onClick={() => setShowApproved((s) => !s)}
//                   role="button"
//                   tabIndex={0}
//                 >
//                   Samþykkt <span className="chev">{showApproved ? '▾' : '▸'}</span>
//                 </div>

//                 {showApproved && categorized.approved.length === 0 && (
//                   <div className="empty">Engar samþykktar.</div>
//                 )}

//                 {showApproved &&
//                   categorized.approved.map((e) => (
//                     <div
//                       key={`app-${e.ssn}-${e.date}-${e.time}`}
//                       className="status-item approved clickable"
//                       onClick={() =>
//                         navigate(`/doctor/changes/${encodeURIComponent(e.ssn.trim())}`)
//                       }
//                       role="button"
//                       tabIndex={0}
//                     >
//                       {e.name} - {e.ssn}
//                       <span className="ok-pill">✓</span>
//                     </div>
//                   ))}
//               </div>
//             </>
//           )}
//         </div>
//       </Background>
//     </>
//   );
// }

//þessi útgáfa sækir úr db
// frontend/src/pages/DoctorChangesPage.tsx
import React, { useEffect, useMemo, useState } from 'react';
import '../styles/DoctorChangesPage.css';
import Header from '../components/Header/Header';
import SearchBar, { SearchBarProps } from '../components/SearchBar/SearchBar';
import { useNavigate } from 'react-router-dom';
import Background from '../components/Background/Background';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchWithAuth } from '../api/fetchWithAuth';

type WorkOrderStatus =
  | 'PENDING'
  | 'PARTIALLY_APPROVED'
  | 'APPROVED'
  | 'REJECTED'
  | 'CANCELLED'
  | 'COMPLETED_EXTERNALLY';

type WorkOrderType = 'CHANGE' | 'REGISTRATION' | 'DISPENSING_STATUS';

type DoctorWorkOrderRow = {
  work_order_id: string;
  patient_id: string;
  order_type: WorkOrderType;
  status: WorkOrderStatus;
  created_at: string;

  // Optional fields your backend might include (highly recommended)
  patient_name?: string | null;
  ssn?: string | null;

  // Optional summary counts (recommended so we can show rejectedCount without extra calls)
  total_items?: number | null;
  denied_items?: number | null;
  unreviewed_items?: number | null;
  approved_items?: number | null;
};

type DoctorWorkOrdersResponse = { rows: DoctorWorkOrderRow[] };

type Bucket = 'sent' | 'rejected' | 'approved';

function toDateLabel(iso: string) {
  const d = new Date(iso);
  const date = d.toLocaleDateString('is-IS');
  const time = d.toLocaleTimeString('is-IS', { hour: '2-digit', minute: '2-digit' });
  return `${date} | ${time}`;
}

function titleForType(t: WorkOrderType): string {
  if (t === 'DISPENSING_STATUS') return 'Stöðubreyting skömmtunar';
  if (t === 'REGISTRATION') return 'Nýskráning sjúklings';
  return 'Breyting á skömmtun';
}

export default function DoctorChangesPage() {
  const [activeTab, setActiveTab] = useState<'medications' | 'history'>('history');
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const [rows, setRows] = useState<DoctorWorkOrderRow[]>([]);
  const [showApproved, setShowApproved] = useState(false);

  const [ssn, setSsn] = useState('');
  const { getAccessTokenSilently } = useAuth0();
  const API_BASE = 'https://api-staging.mitoflux.is';

  const handleSearch = async () => {
    const ssnTrimmed = ssn.trim();
    if (!ssnTrimmed) return;

    try {
      const res = await fetchWithAuth(getAccessTokenSilently, `${API_BASE}/api/patients/search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ssn: ssnTrimmed }),
      });

      if (res.status === 404) {
        navigate('/notfound');
        return;
      }

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`API ${res.status}: ${text}`);
      }

      const data = await res.json();
      const newPatientId = data.patientId as string | undefined;
      if (!newPatientId) throw new Error('Missing patientId in search response');

      navigate(`/doctor/patient/${encodeURIComponent(newPatientId)}`, {
        state: { name: data.name, pharmacy: data.pharmacy },
      });
    } catch (e) {
      console.error(e);
      navigate('/notfound');
    }
  };

  const searchProps: SearchBarProps = {
    value: ssn,
    onChange: setSsn,
    onSearch: handleSearch,
    onMenuClick: () => console.log('menu'),
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError('');

        const res = await fetchWithAuth(
          getAccessTokenSilently,
          `${API_BASE}/api/doctor/work-orders`
        );
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`API ${res.status}: ${text}`);
        }

        const data = (await res.json()) as DoctorWorkOrdersResponse;
        setRows(Array.isArray(data.rows) ? data.rows : []);
      } catch (e: any) {
        console.error(e);
        setError(e?.message || 'Villa kom upp');
      } finally {
        setLoading(false);
      }
    })();
  }, [getAccessTokenSilently]);

  const categorized = useMemo(() => {
    const sent: (DoctorWorkOrderRow & { rejectedCount: number; dateLabel: string })[] = [];
    const rejected: (DoctorWorkOrderRow & { rejectedCount: number; dateLabel: string })[] = [];
    const approved: (DoctorWorkOrderRow & { rejectedCount: number; dateLabel: string })[] = [];

    for (const r of rows) {
      const rejectedCount = Number(r.denied_items ?? 0);
      const dateLabel = toDateLabel(r.created_at);

      const unreviewed = Number(r.unreviewed_items ?? 0);
      const denied = Number(r.denied_items ?? 0);
      const fullyReviewed = unreviewed === 0;

      let bucket: Bucket = 'sent';

      if (fullyReviewed) {
        // If any item denied → Hafnað (even if status is PARTIALLY_APPROVED)
        if (denied > 0) bucket = 'rejected';
        else bucket = 'approved';
      } else {
        bucket = 'sent';
      }

      const withMeta = { ...r, rejectedCount, dateLabel };

      if (bucket === 'approved') approved.push(withMeta);
      else if (bucket === 'rejected') rejected.push(withMeta);
      else sent.push(withMeta);
    }

    // newest first
    const sortDesc = (a: DoctorWorkOrderRow, b: DoctorWorkOrderRow) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime();

    sent.sort(sortDesc);
    rejected.sort(sortDesc);
    approved.sort(sortDesc);

    return { sent, rejected, approved };
  }, [rows]);

  return (
    <>
      <Header center={<SearchBar {...searchProps} />} />

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'medications' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('medications');
            navigate('/doctor');
          }}
        >
          Lyfjaskammtanir
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('history');
            navigate('/doctor/changes');
          }}
        >
          Þínar fyrri breytingar
        </button>
      </div>

      <Background>
        <div className="changes-container">
          <h2>Þínar breytingar á skömmtunum</h2>

          {loading && <div style={{ color: '#fff' }}>Hleð…</div>}
          {error && <div style={{ color: '#fff' }}>{error}</div>}

          {!loading && !error && (
            <>
              {/* Hafnað */}
              <div className="status-section">
                <div className="status-title">Hafnað</div>
                {categorized.rejected.length === 0 && <div className="empty">Engar hafnaðar.</div>}

                {categorized.rejected.map((e) => (
                  <div
                    key={`rej-${e.work_order_id}`}
                    className="status-item rejected clickable"
                    onClick={() =>
                      navigate(`/doctor/changes/${encodeURIComponent(e.work_order_id)}`)
                    }
                    role="button"
                    tabIndex={0}
                  >
                    {/* <span>
                      {(e.patient_name ?? 'Sjúklingur') + ' - kt. ' + (e.ssn ?? e.patient_id)}
                      <span style={{ marginLeft: 10, opacity: 0.9 }}>
                        • {titleForType(e.order_type)} • {e.dateLabel}
                      </span>
                    </span> */}
                    <span>
                      {'Kennitala: ' + (e.ssn ?? e.patient_id)}
                      <span style={{ marginLeft: 10, opacity: 0.9 }}>
                        • {titleForType(e.order_type)} • {e.dateLabel}
                      </span>
                    </span>

                    {e.rejectedCount > 0 && (
                      <div className="notification-dot">{e.rejectedCount}</div>
                    )}
                  </div>
                ))}
              </div>

              {/* Sent */}
              <div className="status-section">
                <div className="status-title">Sent</div>
                {categorized.sent.length === 0 && <div className="empty">Engar óafgreiddar.</div>}

                {categorized.sent.map((e) => (
                  <div
                    key={`sent-${e.work_order_id}`}
                    className="status-item sent clickable"
                    onClick={() =>
                      navigate(`/doctor/changes/${encodeURIComponent(e.work_order_id)}`)
                    }
                    role="button"
                    tabIndex={0}
                  >
                    {/* {(e.patient_name ?? 'Sjúklingur') + ' - kt. ' + (e.ssn ?? e.patient_id)} */}
                    {'Kennitala: ' + (e.ssn ?? e.patient_id)}
                    <span style={{ marginLeft: 10, opacity: 0.9 }}>
                      • {titleForType(e.order_type)} • {e.dateLabel}
                    </span>
                  </div>
                ))}
              </div>

              {/* Samþykkt */}
              <div className="status-section">
                <div
                  className="status-title expandable"
                  onClick={() => setShowApproved((s) => !s)}
                  role="button"
                  tabIndex={0}
                >
                  Samþykkt <span className="chev">{showApproved ? '▾' : '▸'}</span>
                </div>

                {showApproved && categorized.approved.length === 0 && (
                  <div className="empty">Engar samþykktar.</div>
                )}

                {showApproved &&
                  categorized.approved.map((e) => (
                    <div
                      key={`app-${e.work_order_id}`}
                      className="status-item approved clickable"
                      onClick={() =>
                        navigate(`/doctor/changes/${encodeURIComponent(e.work_order_id)}`)
                      }
                      role="button"
                      tabIndex={0}
                    >
                      {/* {(e.patient_name ?? 'Sjúklingur') + ' - kt. ' + (e.ssn ?? e.patient_id)} */}
                      {'Kennitala: ' + (e.ssn ?? e.patient_id)}
                      <span style={{ marginLeft: 10, opacity: 0.9 }}>
                        • {titleForType(e.order_type)} • {e.dateLabel}
                      </span>
                      <span className="ok-pill">✓</span>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </Background>
    </>
  );
}
